import React from 'react';

import { ProtectedApplication } from 'Hooks/useProtectedApplication';

import { useFunnel } from './useFunnel';

export const Funnel: React.FC<{ status: string }> = ({ children, status }) => {
  const { application } = useFunnel({
    routeStatus: status,
  });

  const renderChildren = () => React.Children.map(
    children,
    (child) => React.cloneElement(child as React.ReactElement<{ app: ProtectedApplication }>, {
      app: application,
    }),
  );

  return (
    <>{ renderChildren() }</>
  );
};
